<template>
  <div class="block-carousel__slide" :style="slideStyle">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, type ComputedRef } from 'vue';

const slideWidthPx = inject<ComputedRef<number>>(
  'blockCarouselSlideWidthPx',
  computed(() => 0)
);
const register = inject<() => void>('blockCarouselRegister', () => {});

onMounted(register);

const slideStyle = computed(() => {
  const width = slideWidthPx.value;

  if (width <= 0) {
    return {};
  }

  return {
    flex: `0 0 ${width}px`,
    maxWidth: `${width}px`,
  };
});
</script>

<style lang="scss" scoped>
.block-carousel__slide {
  box-sizing: border-box;
  min-width: 0;
  flex-grow: 0;
  flex-shrink: 0;
  user-select: none;
  backface-visibility: hidden;
}
</style>
